<template>
	<div class="wrap">
		<el-row class="tag color-orange" v-if="!showAll">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-circle-close"></i>
						未完成此患者的运动评估，无法自动生成运动处方，请前去完成评估
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<!-- <a @click="onEvalShow(sideEvalList)" class="goto">去评估</a> -->
					</el-col>
				</el-row>
		<template v-if="showAll">
			<div v-if="isShow">
				<el-row class="tag color-grey" v-if="tag && !hidden && !isSave">
					<el-col :span="18" class="tag_text">
						<i class="el-icon-info"></i>
						已完成对患者的运动评估，自动生成运动处方，请医生确认后发布
					</el-col>
					<el-col :span="6" class="tag_text tag_text_right">
						<a @click="isHidden" class="know">我知道了</a>
					</el-col>
				</el-row>
			</div>
			<el-form ref="form" :model="form" :rules="rules" label-width="80px">
				<div class="body" id="sports">
					<div class="item">
						<h2 class="cf">运动处方</h2>
					</div>
					<div class="item">
						<div v-show="tag">
							<div class="title ">
								评估结果
							<el-button class="exportPdf" v-if="!showSaveBtn" :loading="isLoading" @click="exportPdf">导出处方</el-button>

							</div>
							<div class="text">
								<span>运动风险为：</span>
								<span style="color: #0FCE82;" v-show="form.result==1">低风险</span>
								<span style="color: #EEC211;" v-show="form.result==2">中风险</span>
								<span style="color: #E9395B;" v-show="form.result==3">高风险</span>
							</div>
						</div>
					</div>
					
					<div class="mTop10">
						<div class="title item">
							处方内容
						</div>
						<div>
							<div v-show="!isSave">
								<div class="m20">
									<div class="sx"></div>有氧运动
								</div>
								<div class="desc">
									有氧运动的特点是强度低，有节奏，持续时间较长。要求每次锻炼的时间不少于30分钟，每周坚持3到5次。进行有氧运动时氧气能充分燃烧（即氧化）体内的糖分，还可消耗体内脂肪，增强和改善心肺功能，延缓或改善骨质疏松，减缓精神紧张，改善睡眠质量，有益于疾病康复。
								</div>
								<div>
									<table class="table">
										<tr>
											<td class="topic">
												运动方式
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportTypeValue">
													<el-input v-model="form.content.sportTypeValue" type="textarea" style="margin: 0 10px;"
														placeholder="例如:跑步、乒乓球、游泳等" />
												</el-form-item>
											</td>
											<td class="topic">
												每日运动时间
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportTimeValue">
													<el-input v-model="form.content.sportTimeValue" type="text"
														placeholder="例如:20分钟" />
												</el-form-item>
											</td>
										</tr>
										<tr>
											<td class="topic">
												每周运动天数
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportWeekTimeValue">
													<el-input v-model="form.content.sportWeekTimeValue" type="text"
														placeholder="例如:3天" />
												</el-form-item>
											</td>
											<td class="topic">
												周运动总时间
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportTotalTimeValue">
													<el-input v-model="form.content.sportTotalTimeValue" type="text"
														placeholder="例如:<150分钟" />
												</el-form-item>
											</td>
										</tr>
										<tr>
											<td class="topic">
												运动心率
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportHeartRateValue">
													<el-input v-model="form.content.sportHeartRateValue"  type="textarea"
														placeholder="例如:建议控制在90-100次/分钟之间" />
												</el-form-item>
											</td>
											<td class="topic"></td>
											<td></td>
										</tr>
									</table>
								</div>
								<div class="m20">
									<div class="sx"></div>抗阻训练
								</div>
								<div class="desc">
									抗阻训练是一种保持恒定运动速度的肌肉抗阻训练方法。<br/>
									肌肉抗阻训练可以维护肌肉容量，对维护身体活动速度、耐力、灵敏、协调、平衡等各项身体素质及日常生活自理能力有重要作用、对改善患者血糖、血压、预防及改善骨质疏松等有很好的辅助作用。选择适合患者的抗阻训练方式如以自身重量为阻力的训练或器械练习均可。
								</div>

								<div>
									<table class="table">
										<tr>
											<td class="topic">
												训练部位
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportPartsValue">
													<el-input v-model="form.content.sportPartsValue" type="textarea"
														placeholder="请填写1~3个部位" />
												</el-form-item>
												建议根据患者情况,填写1~3个部位:<br/>肩颈、胸肌、臂肌、腹肌、腰背肌、臀肌、腿肌
											</td>
											<td class="topic">
												每组次数
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportCountValue">
													<el-input v-model="form.content.sportCountValue" type="text"
														placeholder="例如:8-10次/组" />
												</el-form-item>
											</td>
										</tr>
										<tr>
											<td class="topic">
												每次组数
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportGroupValue">
													<el-input v-model="form.content.sportGroupValue" type="text"
														placeholder="例如:1-2组/次"/>
												</el-form-item>
											</td>
											<td class="topic">
												训练时间
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportDateValue">
													<el-input v-model="form.content.sportDateValue" type="text"
														placeholder="例如:10-20分钟/次"  />
												</el-form-item>
											</td>
										</tr>
										<tr>
											<td class="topic">
												训练频次
											</td>
											<td>
												<el-form-item label="" label-width="0" prop="content.sportFrequencyValue">
													<el-input v-model="form.content.sportFrequencyValue" type="text"
														placeholder="例如:每周2次(隔2日一次)" />
												</el-form-item>
											</td>
											<td class="topic"></td>
											<td></td>
										</tr>
									</table>
								</div>
							</div>


							<div v-show="isSave">
								<div class="item">
									<div class="m20">
										<div class="sx"></div>有氧运动
									</div>
									<div class="desc">
										有氧运动的特点是强度低，有节奏，持续时间较长。要求每次锻炼的时间不少于30分钟，每周坚持3到5次。进行有氧运动时氧气能充分燃烧（即氧化）体内的糖分，还可消耗体内脂肪，增强和改善心肺功能，延缓或改善骨质疏松，减缓精神紧张，改善睡眠质量，有益于疾病康复。
									</div>
									<table class="table">
										<tr>
											<td class="topic">
												运动方式
											</td>
											<td>
												{{form.content.sportTypeValue}}
											</td>
											<td class="topic">
												每日运动时间
											</td>
											<td>
												{{form.content.sportTimeValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												每周运动
											</td>
											<td>
												{{form.content.sportWeekTimeValue}}
											</td>
											<td class="topic">
												周运动总时间
											</td>
											<td>
												{{form.content.sportTotalTimeValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												运动心率
											</td>
											<td>
												{{form.content.sportHeartRateValue}}
											</td>
											<td class="topic"></td>
											<td></td>
										</tr>
									</table>
								</div>
								<div class="desc item">
									<el-row>
										<el-col class="tips">
											Tips
										</el-col>
										<el-col :span="22">
											随着运动能力和心肺耐力的提升，逐步增加运动强度和时间，以增强运动效果。
										</el-col>
									</el-row>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>抗阻训练
									</div>
									<div class="desc">
										抗阻训练是一种保持恒定运动速度的肌肉抗阻训练方法。<br/>
										肌肉抗阻训练可以维护肌肉容量，对维护身体活动速度、耐力、灵敏、协调、平衡等各项身体素质及日常生活自理能力有重要作用、对改善患者血糖、血压、预防及改善骨质疏松等有很好的辅助作用。选择适合患者的抗阻训练方式如以自身重量为阻力的训练或器械练习均可。
									</div>
									<table class="table">
										<tr>
											<td class="topic">
												训练部位
											</td>
											<td>
												{{form.content.sportPartsValue}}
											</td>
											<td class="topic">
												每组次数
											</td>
											<td>
												{{form.content.sportCountValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												每次组数
											</td>
											<td>
												{{form.content.sportGroupValue}}
											</td>
											<td class="topic">
												训练时间
											</td>
											<td>
												{{form.content.sportDateValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												训练频次
											</td>
											<td>
												{{form.content.sportFrequencyValue}}
											</td>
											<td class="topic"></td>
											<td></td>
										</tr>
									</table>
								</div>
								<div class="desc item desc3" >
									<el-row>
										<el-col class="tips">
											Tips
										</el-col>
										<el-col :span="22">
											训练前5分钟热身及关节活动，训练后每部位肌肉拉伸与放松10-20秒，每次轮换不同部位训练，先锻炼大肌群（臀部和腿部）再锻炼小肌群（背部、上肢、腹部和颈部），先局部最后达到全身主要肌群锻炼。
										</el-col>
									</el-row>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>主要肌群训练方法
									</div>
									<div>
										<el-row>
											<el-col :span="6" class="tag_text_center">
												<img src="@/assets/images/body_2.png"/>
											</el-col>
											<el-col :span="18">
												<div class="desc desc2">
													<li>
														<span>肩颈：</span>哑铃耸肩、哑铃侧平举等
													</li>
													<li>
														<span>胸肌：</span>俯卧撑、拉力器等
													</li>
													<li>
														<span>臂肌：</span>哑铃颈后臂屈伸、哑铃弯举、卧推等
													</li>
													<li>
														<span>腹肌：</span>仰卧起坐、卷腹、平板支撑、仰卧剪刀腿等
													</li>
													<li>
														<span>腰背肌：</span>俯卧撑、背屈、俯身哑铃飞鸟等
													</li>
													<li>
														<span>臀肌：</span>跪撑伸腕、跪姿侧向抬腿、仰卧桥式挺臀等
													</li>
													<li>
														<span>腿肌：</span>蹲起或负重蹲起、跳台阶、站姿提踵、哑铃箭步蹲等
													</li>
												</div>
											</el-col>
										</el-row>
									</div>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>运动注意
									</div>
									<div class="desc">
										<li>
											1.运动量应从小到大，逐步增加运动负荷，运动时心率上限不可超过风险等级中的最高心率。
										</li>
										<li>
											2.运动前需热身5-10分钟，运动后各肌肉群需拉伸与放松，可减轻运动后肌肉酸痛。
										</li>
										<li>
											3.运动时宜穿着舒适，易排汗，鞋袜不要对足部产生挤压和磨擦。
										</li>
										<li>
											4.运动时不过分用力及动作过猛，避免身体骤然前倾、猛然低头及弯腰，避免屏气，呼吸要自然。
										</li>
										<li>
											5.不要空腹做剧烈运动，以免发生低血糖等危险。
										</li>
										<li>
											6.运动强度要适合自己的体质，不要盲目提高运动强度，以免发生运动风险。
										</li>
										<li>
											7.运动过程中若出现胸闷、胸痛、呼吸困难等不适情况，请立即停止运动并原地休息，如不能缓解，请及时就医，以免 延误病情。
										</li>
									</div>
								</div>
							</div>
						</div>
					</div>
					<el-row class="dealwith">
						<el-col :span="12"  v-if="!showSaveBtn">
							责任医师：{{form.name}}<br/>
							发布时间：{{form.time}}
						</el-col>
						<el-col :span="12" class="tag_text_right" v-if="prescriptionItem.hospitalSportVO?.pushTime">
							推送时间：{{prescriptionItem.hospitalSportVO.pushTime}}
						</el-col>
					</el-row>
				</div>
				
				<div class="body hide" id="sports_print">
					<div class="item">
						<h2 class="cf">运动处方</h2>
					</div>
					<div style="color: #333;font-weight: normal;margin:16px 0;text-align: center;">姓名：{{ medicalRecordDetail.patientName}}&nbsp;&nbsp;&nbsp;&nbsp;科室：{{ medicalRecordDetail.department}}&nbsp;&nbsp;&nbsp;&nbsp;床号：{{medicalRecordDetail.inpatientArea}}-{{ medicalRecordDetail.hospitalBed}}床</div>
					<div class="item">
						<div v-show="tag">
							<div class="title ">
								评估结果
							</div>
							<div class="text">
								<span>运动风险为：</span>
								<span style="color: #0FCE82;" v-show="form.result==1">低风险</span>
								<span style="color: #EEC211;" v-show="form.result==2">中风险</span>
								<span style="color: #E9395B;" v-show="form.result==3">高风险</span>
							</div>
						</div>
					</div>
					<div class="mTop10">
						<div class="title item">
							处方内容
						</div>
						<div>
							<div v-show="isSave">
								<div class="item">
									<div class="m20">
										<div class="sx"></div>有氧运动
									</div>
									<div class="desc">
										有氧运动的特点是强度低，有节奏，持续时间较长。要求每次锻炼的时间不少于30分钟，每周坚持3到5次。进行有氧运动时氧气能充分燃烧（即氧化）体内的糖分，还可消耗体内脂肪，增强和改善心肺功能，延缓或改善骨质疏松，减缓精神紧张，改善睡眠质量，有益于疾病康复。
									</div>
									<table class="table">
										<tr>
											<td class="topic">
												运动方式
											</td>
											<td>
												{{form.content.sportTypeValue}}
											</td>
											<td class="topic">
												每日运动时间
											</td>
											<td>
												{{form.content.sportTimeValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												每周运动
											</td>
											<td>
												{{form.content.sportWeekTimeValue}}
											</td>
											<td class="topic">
												周运动总时间
											</td>
											<td>
												{{form.content.sportTotalTimeValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												运动心率
											</td>
											<td>
												{{form.content.sportHeartRateValue}}
											</td>
											<td class="topic"></td>
											<td></td>
										</tr>
									</table>
								</div>
								<div class="desc item">
									<el-row>
										<el-col class="tips">
											Tips
										</el-col>
										<el-col :span="22">
											随着运动能力和心肺耐力的提升，逐步增加运动强度和时间，以增强运动效果。
										</el-col>
									</el-row>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>抗阻训练
									</div>
									<div class="desc">
										抗阻训练是一种保持恒定运动速度的肌肉抗阻训练方法。<br/>
										肌肉抗阻训练可以维护肌肉容量，对维护身体活动速度、耐力、灵敏、协调、平衡等各项身体素质及日常生活自理能力有重要作用、对改善患者血糖、血压、预防及改善骨质疏松等有很好的辅助作用。选择适合患者的抗阻训练方式如以自身重量为阻力的训练或器械练习均可。
									</div>
									<table class="table">
										<tr>
											<td class="topic">
												训练部位
											</td>
											<td>
												{{form.content.sportPartsValue}}
											</td>
											<td class="topic">
												每组次数
											</td>
											<td>
												{{form.content.sportCountValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												每次组数
											</td>
											<td>
												{{form.content.sportGroupValue}}
											</td>
											<td class="topic">
												训练时间
											</td>
											<td>
												{{form.content.sportDateValue}}
											</td>
										</tr>
										<tr>
											<td class="topic">
												训练频次
											</td>
											<td>
												{{form.content.sportFrequencyValue}}
											</td>
											<td class="topic"></td>
											<td></td>
										</tr>
									</table>
								</div>
								<div class="desc item desc3" >
									<el-row>
										<el-col class="tips">
											Tips
										</el-col>
										<el-col :span="22">
											训练前5分钟热身及关节活动，训练后每部位肌肉拉伸与放松10-20秒，每次轮换不同部位训练，先锻炼大肌群（臀部和腿部）再锻炼小肌群（背部、上肢、腹部和颈部），先局部最后达到全身主要肌群锻炼。
										</el-col>
									</el-row>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>主要肌群训练方法
									</div>
									<div>
										<el-row>
											<el-col :span="6" class="tag_text_center">
												<img src="@/assets/images/body_2.png"/>
											</el-col>
											<el-col :span="18">
												<div class="desc desc2">
													<li>
														<span>肩颈：</span>哑铃耸肩、哑铃侧平举等
													</li>
													<li>
														<span>胸肌：</span>俯卧撑、拉力器等
													</li>
													<li>
														<span>臂肌：</span>哑铃颈后臂屈伸、哑铃弯举、卧推等
													</li>
													<li>
														<span>腹肌：</span>仰卧起坐、卷腹、平板支撑、仰卧剪刀腿等
													</li>
													<li>
														<span>腰背肌：</span>俯卧撑、背屈、俯身哑铃飞鸟等
													</li>
													<li>
														<span>臀肌：</span>跪撑伸腕、跪姿侧向抬腿、仰卧桥式挺臀等
													</li>
													<li>
														<span>腿肌：</span>蹲起或负重蹲起、跳台阶、站姿提踵、哑铃箭步蹲等
													</li>
												</div>
											</el-col>
										</el-row>
									</div>
								</div>
								<div class="item">
									<div class="m20">
										<div class="sx"></div>运动注意
									</div>
									<div class="desc">
										<li>
											1.运动量应从小到大，逐步增加运动负荷，运动时心率上限不可超过风险等级中的最高心率。
										</li>
										<li>
											2.运动前需热身5-10分钟，运动后各肌肉群需拉伸与放松，可减轻运动后肌肉酸痛。
										</li>
										<li>
											3.运动时宜穿着舒适，易排汗，鞋袜不要对足部产生挤压和磨擦。
										</li>
										<li>
											4.运动时不过分用力及动作过猛，避免身体骤然前倾、猛然低头及弯腰，避免屏气，呼吸要自然。
										</li>
										<li>
											5.不要空腹做剧烈运动，以免发生低血糖等危险。
										</li>
										<li>
											6.运动强度要适合自己的体质，不要盲目提高运动强度，以免发生运动风险。
										</li>
										<li>
											7.运动过程中若出现胸闷、胸痛、呼吸困难等不适情况，请立即停止运动并原地休息，如不能缓解，请及时就医，以免延误病情。
										</li>
									</div>
								</div>
							</div>
						</div>
					</div>
					<el-row v-if="!showSaveBtn" class="dealwith">
						<el-col :span="12">
							责任医师：{{form.name}}
						</el-col>
						<el-col :span="12" class="tag_text_right">
							发布时间：{{form.time}}
						</el-col>
					</el-row>
				</div>
				
				<div v-show="isShow">
					<div class="save" v-if="showSaveBtn">
						<el-button type="primary" :loading="isLoading" @click="save('form')">发 布</el-button>
					</div>
					<div class="save" v-if="!showSaveBtn">
						<el-popconfirm confirmButtonText='删除' title="确定删除处方吗？" @confirm="delPrescription">
							
							<el-button slot="reference" style="float: left;" type="danger" :loading="isLoading" >删除处方</el-button>
						</el-popconfirm>

						<el-button type="primary" :loading="isLoading" @click="update">修改处方</el-button>
						<el-button :loading="isLoading" @click="dialogVisible=true" v-if="patientInfo.wxBindingState == 1">推送处方</el-button>
						<span style="opacity: 0;">{{ this.prescriptionItem.hospitalSportVO.id }}</span>
					</div>
				</div>

			</el-form>
		</template>

		<SendDialog v-if="dialogVisible" :dialogVisible.sync="dialogVisible" type="3"  :prescriptionId="prescriptionItem.hospitalSportVO.id"  />

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import htmlToPdf from '@/service/htmlToPdf'
	import SendDialog from './sendDialog.vue';

	export default {
		components: {
			SendDialog
		},
		props: {
			patientInfo:{
				required: true
			},
			recordId: {
				required: true
			},
			patientId: {
				required: true
			},
			datasources: {
				// required: true
				default: null

			},
			onEvalShow: {
				type: Function,
				default: null
			},
			isShow:{
				type:Boolean,
				default:true
			},
			sideEvalList:{
				// required: true
				default: null

			},
			medicalRecordDetail:{
				// required:true
				default: null

			}

		},
		data() {
			return {
				tag: true,
				hidden: false,
				form: {
					result: 0,
					content: {
						sportTypeValue: '',
						sportTimeValue: '',
						sportWeekTimeValue: '',
						sportTotalTimeValue: '',
						sportHeartRateValue: '',
						sportPartsValue: '',
						sportCountValue: '',
						sportGroupValue: '',
						sportDateValue: '',
						sportFrequencyValue: ''
					},
					name: "",
					time: "",
				},
				isLoading: false,
				showSaveBtn: true,
				isSave: false,
				prescriptionItem: {},
				rules: {
					'content.sportTypeValue': [{
						required: true,
						message: '请输入运动方式',
						trigger: 'blur'
					}],
					'content.sportTimeValue': [{
						required: true,
						message: '请输入每天运动时间'
					}],
					'content.sportWeekTimeValue': [{
						required: true,
						message: '请输入每周运动天数'
					}],
					'content.sportTotalTimeValue': [{
						required: true,
						message: '请输入周运动总时间'
					}],
					'content.sportHeartRateValue': [{
						required: true,
						message: '请输入运动心率'
					}],
					'content.sportPartsValue': [{
						required: true,
						message: '请输入训练部位'
					}],
					'content.sportCountValue': [{
						required: true,
						message: '请输入每组次数'
					}],
					'content.sportGroupValue': [{
						required: true,
						message: '请输入每次组数'
					}],
					'content.sportDateValue': [{
						required: true,
						message: '请输入训练时间'
					}],
					'content.sportFrequencyValue': [{
						required: true,
						message: '请输入训练频次'
					}]
				},
				dialogVisible:false,
				showAll:true,
			}
		},
		async created(){
			let query=this.$route.query;
			if(Number(query.datasources)!=1&&Number(query.datasources)!=2){
				let res=await api.checkPreVisibleTypes({
					recordId:this.recordId,
					type:3
				})
				this.showAll=res.data;
			}else{
				this.showAll=true
			}
		},
		methods: {
			async init(prescriptionItem) {

				this.prescriptionItem = prescriptionItem;
				if (this.prescriptionItem.hospitalSportVO.evalResult != null) {
					let evalResult = JSON.parse(this.prescriptionItem.hospitalSportVO.evalResult);
					if (evalResult.evalError == "") {
						this.tag = true;
						if (this.prescriptionItem.hospitalSportVO.content == null) {
							let evalContent = evalResult.evalContent;
							if (evalContent.indexOf("高风险") > -1) {
								this.form.result = 3
							} else if (evalContent.indexOf("中风险") > -1) {
								this.form.result = 2
							} else if (evalContent.indexOf("低风险") > -1) {
								this.form.result = 1
							}
							let content1 = evalResult.prescription[0].aerobic;
							let content2 = evalResult.prescription[0].resistance;
							
							this.form.content.sportTimeValue = content1.dayTime;
							this.form.content.sportTypeValue = content1.mode;
							this.form.content.sportWeekTimeValue = content1.weekDay;
							this.form.content.sportHeartRateValue = content1.heartRate;
							this.form.content.sportTotalTimeValue = content1.weekTime;

							this.form.content.sportFrequencyValue = content2.frequency;
							this.form.content.sportCountValue = content2.timesOneGroup;
							this.form.content.sportPartsValue = content2.trainingPosition;
							this.form.content.sportDateValue = content2.time;
							this.form.content.sportGroupValue = content2.GroupsOneTime;
						}
					}else{
						this.tag = false;
					}
				}else{
					this.tag = false;
				}
				if (this.prescriptionItem.hospitalSportVO.content != null) {
					this.hidden = true;
					let content = JSON.parse(this.prescriptionItem.hospitalSportVO.content);
					if(content.result != 0 && content.result != null){
						this.tag = true;
					}
					
					this.form = content;
					this.showSaveBtn = false;
					this.isSave = true;
				}
			},
			save(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						this.isLoading = true;
						let user = JSON.parse(localStorage.getItem("user"));
						let myDate = new Date();
						let time = myDate.getFullYear() + "/" + (myDate.getMonth() + 1) + "/" + myDate
						.getDate() + " " + myDate.toLocaleTimeString();
						let data = [];
						data.push({
							"content": JSON.stringify({
								result: this.form.result,
								content: this.form.content,
								name: user.data.name,
								time: time
							}),
							"datasources": this.datasources,
							"patientId": this.patientId,
							"prescriptionType": 3,
							"recordId": this.recordId,
							"state": 1
						});
						let res = await api.addPrescription(data);
						this.isLoading = false;
						if (res.code != 1000) {
							return this.$message.error(res.message);
						}
						this.showSaveBtn = false;
						this.isSave = true;

						this.form = {
							result: this.form.result,
							content: this.form.content,
							name: user.data.name,
							time: time
						}
						this.$emit('trigger-event',3);
					}
				});
			},
			update() {
				this.showSaveBtn = true;
				this.isSave = false;
				// this.prescriptionItem.hospitalSportVO.pushTime=null
			},
			exportPdf() {
				htmlToPdf.outPutPdfFn(document.querySelector("#sports_print"), "运动处方");
			},
			isHidden() {
				this.hidden = true;
			},
			async delPrescription(){
				let res=await api.delPrescription({
					id:this.prescriptionItem.hospitalSportVO.id,
					prescriptionType:3
				})
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.showSaveBtn = true;
				this.isSave = false;

				this.prescriptionItem.hospitalSportVO.content = null;
				this.init(this.prescriptionItem)
				this.$emit('trigger-event',3);

			}
		}
	}
</script>

<style lang="less" scoped>
.wrap{
	min-height: 300px;
}
::v-deep .alert{
		margin: 0 auto;
		width: 80%;
	}
	.body {
		padding: 20px 120px;
		font-size: 20px;
		color: #409EFF;
	}
	.exportPdf{
		float: right;
		margin-top: -18px;
		background: #fff;
		color: #699ce4;
		border-radius: 20px;
		padding: 6px 12px;
	}
	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
	}

	.save {
		text-align: right;
		padding: 20px 120px;
	}

	.dealwith {
		color: #333333;
		font-size: 14px;
		padding-top: 20px;
	}

	.saveText {
		background-color: #EFF8FE;
		border-color: #409EFF;
	}

	.text {
		font-size: 20px;
		color: #333333;
		margin: 15px 0;
	}

	.tag {
		border-radius: 5px;
		height: 35px;
		margin: 0 30px;
		padding: 0 15px;
		font-size: 13px;
	}

	.color-grey {
		background-color: #E6E6E6;
		color: #4D4D4D;
	}

	.color-orange {
		background-color: #FFECEC;
		color: #FF5D5D;
	}

	table {
		border: 1px solid #4D4D4D;
		border-collapse: collapse;
		border-spacing: 0;
	}

	table th {
		height: 40px;
		border: 1px solid #4D4D4D;
	}

	table td {
		height: 40px;
		border: 1px solid #4D4D4D;
		width: 25%;
	}

	.topic {
		background-color: #CFEAFC;
	}

	.sx {
		width: 5px;
		background-color: #409EFF;
		height: 22px;
		border-radius: 5px;
		float: left;
		margin-right: 10px;
		margin-top: 3px;
	}

	.desc {
		border-radius: 5px;
		border: 1px solid #409EFF;
		background-color: #EFF8FE;
		margin: 30px 0;
		padding: 20px 20px 20px 40px;
		font-size: 14px;
		color: #333333;
		line-height: 40px;
	}
	.desc3{
		background-color: #fff;
		border: 1px dashed #409EFF;
	}
	
	.desc2{
		width: 90%;
		margin-top: 40px;
	}

	.desc1 {
		background-color: #fff;
		border: 1px solid #E6E6E6;
	}

	input {
		height: 30px;
		width: 200px;
		font-size: 18px;
	}
	
	// .el-form .el-input:not(.el-transfer-panel__filter){
	// 	height: 30px;
	// }

	/deep/.el-form-item__content {
		margin-top: 18px;
	}

	/deep/.el-form-item__error {
		margin-left: 20%;
	}
	
	.know{
		color: #4D4D4D;
		cursor: pointer;
	}
	
	.goto{
		color: #FF5D5D;

		cursor: pointer;
	}
	
	.tag_text {
		line-height: 35px;
		font-size: 14px;
	}
	
	.tag_text_right {
		text-align: right;
	}
	
	.tag_text_center {
		text-align: center;
	}
	
	.title {
		border-bottom: 3px solid #409EFF;
		margin-bottom: 20px;
		font-size: 20px;
	}
	
	.cf {
		font-size: 24px;
		text-align: center;
		color: #333333
	}
	
	.mTop10 {
		margin-top: 10px;
	}
	
	.m20 {
		margin: 20px 0;
	}
	
	.table{
		text-align: center;
		font-size: 14px;
		color: #333333;
		width: 100%;
	}
	
	/deep/.el-input__inner{
		width: 60%;
		height: 30px;
	}
	
	.tips{
		color:#409EFF; 
		font-size:20px;
		width: 80px;
	}
	
	#sports_print{
		.body {
			padding: 20px 120px;
			font-size: 18px;
			color: #409EFF;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
		}
		
		
		.save {
			text-align: right;
			padding: 20px 120px;
		}
		
		.dealwith {
			color: #000;
			font-size: 16px;
			padding-top: 20px;
		}
		
		.saveText {
			background-color: #EFF8FE;
			border-color: #409EFF;
		}
		
		.text {
			font-size: 24px;
			margin: 15px 0;
			color: #000;
		}
		
		.tag {
			border-radius: 5px;
			height: 35px;
			margin: 0 30px;
			padding: 0 15px;
			font-size: 16px;
		}
		
		.h20{
			height: 20px;
		}
		
		.color-grey {
			background-color: #E6E6E6;
			color: #4D4D4D;
		}
		
		.color-orange {
			background-color: #FEF8DE;
			color: #EEC211;
		}
		
		table {
			border: 1px solid #4D4D4D;
			border-collapse: collapse;
			border-spacing: 0;
		}
		
		table th {
			height: 40px;
			border: 1px solid #4D4D4D;
		}
		
		table td {
			padding: 10px;
			height: 20px;
			border: 1px solid #4D4D4D;
			width: 25%;
		}
		
		.table{
			text-align: center;
			font-size: 17px;
			color: #333333;
			width: 100%;
		}
		
		.topic {
			background-color: #CFEAFC;
		}
		
		.sx {
			width: 5px;
			background-color: #409EFF;
			height: 22px;
			border-radius: 5px;
			float: left;
			margin-right: 10px;
			margin-top: 3px;
		}
		
		.el-form .el-input:not(.el-transfer-panel__filter){
			width: 60%;height: 30px;
		}
		
		.desc {
			border-radius: 5px;
			border: 1px solid #409EFF;
			background-color: #EFF8FE;
			margin: 30px 0;
			padding: 20px 20px 20px 40px;
			font-size: 18px;
			color: #000;
			line-height: 40px;
		}
		
		/deep/.el-form-item__content{
			margin-top: 18px;
		}
		
		/deep/.el-form-item__error {
			margin-left: 40%;
		}
		
		.text_dec{
			text-align: left;
			padding-left: 5px;
			line-height: 40px;
			margin-top: 18px
		}
		
		.know{
			color: #4D4D4D;
			cursor: pointer;
		}
		
		.goto{
			color: #EEC211;
			cursor: pointer;
		}
		
		.tag_text {
			line-height: 35px;
			font-size: 18px;
		}
		
		.tag_text_right {
			text-align: right;
		}
		
		.title {
			border-bottom: 3px solid #409EFF;
			margin-bottom: 20px;
			font-size: 26px;
		}
		
		.cf {
			font-size: 30px;
			text-align: center;
			color: #000
		}
		
		.mTop10 {
			margin-top: 10px;
		}
		
		.m20 {
			margin: 40px 0;
		}
		
	}
	
	
	.hide{
		position: absolute;
		z-index: -999;
	}
</style>
